export const initCriterion = {
  id: null,
  internal_id: null,
  name: '',
  description: '',
  conditions: [],
  shipping_method_ids: [],
}
